export var IdLogging;
(function (IdLogging) {
    IdLogging[IdLogging["Default"] = 0] = "Default";
    IdLogging[IdLogging["NetworkIn"] = 1] = "NetworkIn";
    IdLogging[IdLogging["NetworkOut"] = 2] = "NetworkOut";
    IdLogging[IdLogging["Graphics"] = 3] = "Graphics";
    IdLogging[IdLogging["Animation"] = 4] = "Animation";
    IdLogging[IdLogging["LandingPages"] = 5] = "LandingPages";
    IdLogging[IdLogging["Shop"] = 6] = "Shop";
    IdLogging[IdLogging["Sound"] = 7] = "Sound";
    IdLogging[IdLogging["Store"] = 8] = "Store";
    IdLogging[IdLogging["Tracking"] = 9] = "Tracking";
})(IdLogging || (IdLogging = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/logging/IdLogging.ts
// module id = 449
// module chunks = 3